import axios from 'axios';

export const getLatLng = async (addressObject, apiKey) => {
    const address = encodeURI(
        `${addressObject.address_number} ${addressObject.street_name}, ${addressObject.district}, ${addressObject.city}, ${addressObject.state}, ${addressObject.zipcode}, ${addressObject.state}, ${addressObject.country}`
    )

    let url = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${apiKey}`
    
    const response = await axios.get(url)
    let result = {lat:'',lng: ''};
    if(response.data.results[0]){
        result = response.data.results[0].geometry.location
    }
    return { lat: result.lat, lng: result.lng }
};